// Visão "por white label": white label → método de pagamento → configurações.
//
// Mesmo painel da visão por meio de pagamento, com a outra dimensão no
// accordion externo. Nenhuma regra vive aqui: se algo precisar ser diferente
// entre as duas visões, o lugar é o painel compartilhado — duas listas de
// regras paralelas divergem na primeira mudança.
import { ProcessorConfigGroupedPanel } from "./processor-config-grouped-panel"

export const ProcessorConfigPanelByWhiteLabel = () => (
  <ProcessorConfigGroupedPanel grouping="byWhiteLabel" />
)
